const url = {
    //Local    
    //cas: 'https://auth.test.espol.edu.ec',
    //localBack: 'https://localhost:44326/api/',
    //localFront: 'https://localhost:44305/',
    //Sever-Pruebas
    //localBack : 'http://192.168.253.6:8098/api/',
    //localFront : 'http://192.168.253.7:8098/',
    //cas: 'https://auth.test.espol.edu.ec',
    fechaInicio: '2022-07-21T08:00:00',
    fechaFin: '2022-07-30T00:00:00',
    //produccion
    localBack : 'https://wssaac.espol.edu.ec/validacioncargadirectivo/api/',
    localFront: 'https://saac.espol.edu.ec/validacioncargadirectivo/',
    cas: 'https://auth.espol.edu.ec',
}

export default url;